module.exports = __webpack_public_path__ + "img/end5.99a2e74d.svg";